import { useMemo } from 'react';
import type { ToastMessageProps } from '@standardsdigital/ui-components/Toast';
import type { NavigateOptions } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import {
  clearToastMessages,
  showErrorToast,
  showInfoToast,
  showSuccessToast,
  showToast,
  showWarningToast,
} from '@/redux/slices/messageSlice';
import { useAppDispatch } from '@/redux/hooks';
import { localizePathname } from './util';

export function useLocalizedNavigate() {
  const navigate = useNavigate();

  const localizedNavigate = (to: string, options?: NavigateOptions) =>
    navigate(localizePathname(to), options);

  return localizedNavigate;
}

export const useToast = () => {
  const dispatch = useAppDispatch();

  return useMemo(
    () => ({
      success: (message: string) => dispatch(showSuccessToast(message)),
      error: (message: string) => dispatch(showErrorToast(message)),
      warning: (message: string) => dispatch(showWarningToast(message)),
      info: (message: string) => dispatch(showInfoToast(message)),
      message: (message: Omit<ToastMessageProps, 'id'>) =>
        dispatch(showToast(message)),
      clear: () => dispatch(clearToastMessages()),
    }),
    [dispatch],
  );
};
